// Module
var code = "<div class=\"teamManagement-avatar-Name\">{firstname} {lastname}</div>\n<div class=\"Avatar-Role\">{[L(values.role.namePrompt, values.role.name)]}</div>\n";
// Exports
module.exports = code;